(() => {
  const SELECTOR = 'localization-form.ah-header-currency';

  function closeCurrency(root) {
    const button = root.querySelector('.ah-header-currency-toggle');
    const panel = root.querySelector('.ah-header-currency-list');
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', 'false');
    panel.setAttribute('hidden', '');
  }

  function openCurrency(root) {
    const button = root.querySelector('.ah-header-currency-toggle');
    const panel = root.querySelector('.ah-header-currency-list');
    if (!button || !panel) return;
    document.querySelectorAll(SELECTOR).forEach((otherRoot) => {
      if (otherRoot !== root) closeCurrency(otherRoot);
    });
    button.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
  }

  function setup(root) {
    if (!root || root.dataset.ahCurrencyReady === 'true') return;

    const button = root.querySelector('.ah-header-currency-toggle');
    const panel = root.querySelector('.ah-header-currency-list');
    const form = root.querySelector('form');
    const input = root.querySelector('input[name="country_code"]');

    if (!button || !panel || !form || !input) return;

    root.dataset.ahCurrencyReady = 'true';

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const isOpen = button.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeCurrency(root);
      } else {
        openCurrency(root);
      }
    }, true);

    root.querySelectorAll('.ah-header-currency-list a[data-value]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const value = link.getAttribute('data-value');
        if (!value) return;

        input.value = value;
        form.submit();
      }, true);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  document.addEventListener('click', (event) => {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      if (!root.contains(event.target)) closeCurrency(root);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(SELECTOR).forEach(closeCurrency);
  });
})();
